import * as React from 'react';
import { Controller } from "./Infraestructure/Controller";
import { ViewApp } from "./Components/View";
import { isMobile } from 'react-device-detect';


const ManagerApp = () => {
    const controller = Controller();

    React.useEffect(() => {
        if (isMobile) controller.init();
        // controller.termns()
        return () => {
            if (isMobile) controller.end();
        }
        // eslint-disable-next-line
    }, []);

    return (<ViewApp loadingMaestros={controller.loadingMaestros} availableUpdate={controller.availableUpdate} updateApp={controller.updateApp} updating={controller.updating} />);
};

export default ManagerApp;